<template>
<div class="detail-settings__calibration">
  <div class="detail-settings__calibration__wrapper">
  <div class="detail-settings__calibration__col1" v-if="showInEnv([env_tentacles, env_flower])">
    <div class="detail-settings__calibration__row">&nbsp;</div>
      <div class="detail-settings__calibration__row" :key="property.label"
           v-for="property in batch.type.properties">
                <span class="detail-settings__calibration__row__label">
                  {{ property.label }}:
                </span>
          <span class="detail-settings__calibration__row__input dropdown"
                v-if="property.type === 'choices'">
                  <select @change="refreshSecondaryBatch" v-model="m[property.key]">
                    <option v-for="choice in property.values"
                            :value="choice"
                            :key="property.key + '_' + choice"
                            :selected="device && device.properties &&
                            device.properties[property.key] === choice">
                        {{ truncateTo(choice, 8, '..') }}
                    </option>
                  </select>
                </span>
      </div>
  </div>
    <div class="detail-settings__calibration__col2" v-if="!disabledActions && showInEnv([env_tentacles, env_flower])" >
        <div class="detail-settings__calibration__row size-2"
             v-if="secondaryBatchId !== secondaryBatchOriginalId">
            <button @click="updateTentacleProperties">
                {{ $t('detail.select_props') }}
            </button>
        </div>
    </div>
  </div>
    <div class="detail-settings__calibration__row batch-row" v-if="showInEnv([env_tentacles, env_flower])">
        <span class="detail-settings__calibration__row__label">{{ $t('detail.batch') }}: </span>
        <span class="detail-settings__calibration__row__value info-text">
              {{ secondaryBatchOriginal }}
            </span>
    </div>
    <div class="detail-settings__calibration__row"
         v-if="secondaryBatchId !== secondaryBatchOriginalId && showInEnv([env_tentacles, env_flower])">
        <span class="detail-settings__calibration__row__label">{{ $t('detail.selected_batch') }}: </span>
        <span class="detail-settings__calibration__row__value">
              <span :class="secondaryBatchId === null ? 'strong' : ''">
                {{ secondaryBatch }}
              </span>
            </span>
    </div>


    <div class="detail-settings__calibration__cols" v-if="showInEnv(env_etentacles)">
        <div class="detail-settings__calibration__row"
             v-for="(value, property) in properties">
            <span class="detail-settings__calibration__row__label">
              {{ property }}:
            </span>
            <span class="detail-settings__calibration__row__settings " >
            {{ value }}
            </span>
        </div>
    </div>
</div>
</template>

<script>
// import store from '@/store';
import BatchServices from '@/services/BatchServices';
import store from '@/store';

export default {
  name: 'BatchSelection',
  components: {},
  props: {
    properties: {
      type: Object,
      required: true,
    },
    batch: {
      type: Object,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
    resultData: {
      type: Object,
      required: false,
    },
    disabledActions: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
      env_flower: process.env.VUE_APP_ENV_FLOWER,
      secondaryBatchOriginal: '',
      secondaryBatch: null,
      secondaryBatchId: null,
      secondaryBatchOriginalId: null,
      mOriginal: Object.assign({}, this.device.properties),
      m: Object.assign({}, this.device.properties),
    };
  },
  watch: {
    changedConfiguration(value) {
      this.$emit('dirtyBatch', value);
    },
  },
  computed: {
    sensor() {
      return this.device.sensors.find(sensor => sensor.name.toLowerCase() === 'moisture');
    },
    changedConfiguration() {
      return JSON.stringify(this.m) !== JSON.stringify(this.device.properties);
    },
  },
  mounted() {
    this.fullUpdateTentacleProperties();

    if (this.resultData) {
      this.resultData.id = this.device.id;
      this.resultData.properties = JSON.stringify(this.m);
    }
  },
  updated() {
    const devProps = JSON.stringify(this.device.properties);
    const mProps = JSON.stringify(this.mOriginal);
    if (devProps !== mProps) {
      this.m = Object.assign({}, this.device.properties);
      this.mOriginal = Object.assign({}, this.device.properties);
      this.fullUpdateTentacleProperties();
    }
  },
  methods: {
      truncateTo: function (text, length, suffix) {
        if (text.length > (length + suffix.length)) {
            return text.substring(0, length) + suffix;
        } else {
            return text;
        }
    },
    showInEnv(type) {
      if (Array.isArray(type)) {
        return type.includes(process.env.VUE_APP_ENVIRONMENT);
      }
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
    fullUpdateTentacleProperties() {
      const propsAsString = JSON.stringify(this.device.properties);
      BatchServices.getSecondaryBatch(this.device.batch.type.id, propsAsString)
        .then((data) => {
          this.secondaryBatchOriginal = data.data.response.batchName;
          this.secondaryBatch = data.data.response.batchName;
          this.secondaryBatchOriginalId = data.data.response.batchId;
          this.secondaryBatchId = data.data.response.batchId;
        });
    },
    refreshCalibrationData() {
      store.dispatch('tentacle/setUnitByID', this.device.id);
      this.deviceOnlyOriginal = this.deviceOnly;
    },
    refreshSecondaryBatch() {
      const self = this;
      // device.properties
      const generatedName = `${Object.values(this.m).join('-')} (New)`;
      BatchServices.getSecondaryBatch(this.device.batch.type.id, JSON.stringify(this.m))
        .then((data) => {
          self.secondaryBatch = data.data.response.batchName ? data.data.response.batchName
            : generatedName;
          self.secondaryBatchId = data.data.response.batchId;
        });

      if (this.resultData) {
        this.resultData.id = this.device.id;
        this.resultData.properties = JSON.stringify(this.m);
      }
    },
    updateTentacleProperties() {
      const data = [{
        id: this.device.id,
        properties: JSON.stringify(this.m),
      }];

      this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
        if (response.status === 200) {
          this.device.properties = Object.assign({}, this.m);
          this.fullUpdateTentacleProperties();
          this.flash('Tentacles updated', 'success');

          if (this.sensor) {
            const sensorData = { id: this.sensor.id, useBatchCalibration: true };
            this.$store.dispatch('tentacle/updateSensors', [sensorData]).then((response2) => {
              if (response2.status === 200) {
                this.refreshCalibrationData();
                this.flash('Sensor updated', 'success');
              }
            });
          }
        }
      }).then(() => {
        if (this.isLocked) {
          const attr = {
            min: false,
            max: false,
            sensorId: this.sensor.id,
          };

          this.$store.dispatch('tentacle/calibrateBatchBySensor', attr).then(() => {
            this.refreshCalibrationData();
            this.flash('The calibration for the sensor has been done.', 'success');
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-settings {
  &__moisture_warning {
    color: red;
    margin-bottom: 1rem;
    font-weight: bold;
  }

  &__device-only {
    color: #f39c12;
    font-weight: bold;
    margin-left: -5px;
  }

  &__calibration {
    padding: 10px 3rem;
    font-size: 1.3rem;
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid $border-color;

    &__wrapper {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    &__cols {
      flex: 1 0 80%;
    }

    &__col1 {
      flex: 1 0 62%;
      min-width: 270px;
    }

    &__col2 {
      flex: 1 0 38%;
      text-align: right;
      margin-top: 3rem;

      button {
        border-radius: 4px;
        min-width: 125px;
        padding-top: 7px;
        padding-bottom: 7px;
        cursor: pointer;
        background-color: $company-color;
        color: #f7f7f7;
        border: none;

        &:hover {
          background-color: $company-color-light;
        }
      }
    }

    &__row {
      line-height: 3.3rem;

      &.size-2 {
        line-height: 3.8rem;
      }

      &.batch-row {
        margin-top: 3rem;
      }

      &__label-selection {
        font-weight: bold;
        min-width: 155px;
        display: inline-block;

        &.calibrated_by {
          font-weight: normal;
          margin-top: 20px;
          color: darkblue;
        }
      }

      &__label {
        font-weight: bold;
        min-width: 147px;
        display: inline-block;

        &.calibrated_by {
          font-weight: normal;
          margin-top: 20px;
          color: darkblue;
        }
      }

      .info-text {
        color: $grey;
      }

      &__input > select {
          min-width: 12rem;
      }

      &__value {
        .strong {
          color: #ff5050;
        }
      }

      &__settings {
          padding-right: 20px;
          float: right;
        .strong {
          color: #ff5050;
        }
      }
    }
  }
}
</style>
